import React from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';

import classNames from 'classnames';

import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';

import {useIsOneStepAvailable} from 'hooks/useIsOneStepAvailable/useIsOneStepAvailable';

import s from './savedCardsSwitcher.scss';

type PropsType = {
    isSavedCardsShown: boolean;
    onChange: () => void;
};

/**
 * Switcher between card form and saved cards list
 * for credit card payment method on checkout
 */
export const SavedCardsSwitcher: React.FC<PropsType> = ({isSavedCardsShown, onChange}) => {
    const buttonText = `use ${isSavedCardsShown ? 'different' : 'saved'} card`;
    const {isOneStepAvailable} = useIsOneStepAvailable();

    const handleClick = () => {
        sendDesktopAnalyticsEvent(CHECKOUT_PAYMENT_STEP, {
            message: `CTA - ${buttonText}`,
            method: 'Payment',
        });
        onChange();
    };

    return (
        <div className={classNames(s.switcher, {[s.oneStep]: isOneStepAvailable})}>
            Or,{' '}
            <button
                className={s.switcherButton}
                data-test-name="useDiffCard"
                onClick={handleClick}
                type="button"
            >
                {buttonText}
            </button>
        </div>
    );
};
